import {GTagClientAndSessionId} from 'app/gtag';

/** Message sent to the legacy backend with Google Analytics identifiers. */
export interface GTagMessageForLegacyBe {
    /** Message type expected by the legacy backend. */
    type: 'gtagInit';
    /** Payload consumed by the legacy backend Google Analytics bridge. */
    payload: {
        /** Google Analytics client identifier. */
        gaClientId: string,
        /** Google Analytics session identifier. */
        gaSessionId: string,
    };
}

// 'gtagInit' type, 'gaClientId' and 'gaSessionId' are agreed GA field names with legacy BE .NET code
/**
 * Builds the message forwarded to the legacy backend with Google Analytics identifiers.
 *
 * @param gTagIds Google Analytics client and session identifiers.
 *
 * @returns Message payload compatible with the legacy backend.
 */
export const genGTagMessageForLegacyBe = (gTagIds: GTagClientAndSessionId): GTagMessageForLegacyBe => ({
    type: 'gtagInit',
    payload: {
        gaClientId: gTagIds.clientId,
        gaSessionId: gTagIds.sessionId,
    },
});
